import { ProductCreatePage } from "@/features/product/pages/ProductCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product/create")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: [
					"product_item.create_non_consignment",
					"product_item.create_consignment",
				],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: ProductCreatePage,
});
